import { optionalToJS } from './utils';

const tickerFromId = (state, id) => state.entities.getIn(['tickers', id.toString()]);

const tickersFromIds = (state, ids) => ids.map(id => tickerFromId(state, id));

const tickerSeriesFromId = (state, id) => {
  if (state.tickerSeries.ids.includes(id)) {
    return state.entities
                .getIn(['tickerSeries', id.toString()])
                .update('tickers', tickers => tickersFromIds(state, tickers));
  }
};

const tickerSeriesFromIds = (state, ids) => ids.map(id => tickerSeriesFromId(state, id));

const tickerSeriesAll = (state) => tickerSeriesFromIds(state, state.tickerSeries.ids);

export const getTickerSeriesList = (state) => tickerSeriesAll(state).toJS();

export const getTickerSeries = (state, id) => optionalToJS(tickerSeriesFromId(state, id));

export const getTickersForPositionUpdate = (tickers) => {
  const tickersToUpdate = [];

  tickers.forEach((ticker, idx) => {
    // To minimise the number of PATCH requests, we will exclude any tickers that haven't
    // changed position.
    if (ticker.position != idx) {
      // For tickers with changed positions, we include only the bits that actually need to be
      // updated, the id for reference, and the position.
      tickersToUpdate.push({id: ticker.id, position: idx});
    }
  });

  return tickersToUpdate;
};
export const isFetchingTickerSeries = (state) => state.tickerSeries.isFetching;



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/selectors/tickers.js